import { defineStore } from 'pinia';
// import { QueryInboxMessageRes } from '@lingtu/apis/entities';
import to from 'await-to-js';
import { apis } from '/@/apis';

const { queryInboxMessage, readMessage, readAll, unreadMessageNum, overview } = apis.notify;

export const useNotifyStore = defineStore({
  id: 'notify',
  state: () => ({
    notifies: [],
    overview: [],
    unreadNum: 0,
    loaded: true,
    offset: undefined,
  }),
  actions: {
    async refetchNotifies() {
      this.loaded = false;
      this.offset = undefined;
      this.notifies = [];
      this.fetchNotifies();
    },

    async fetchNotifies() {
      const SIZE = 20;
      const [err, res] = await to(
        queryInboxMessage({
          appCode: 'aiad',
          offset: this.offset,
          size: SIZE,
        }),
      );
      if (!err) {
        if (res.length < SIZE) {
          this.loaded = true;
        }

        this.notifies.push(...res);
        this.offset = res[res.length - 1]?.id;
      }
    },

    // 获取所有组织的未读信息
    async fetchOverview() {
      const [err, res] = await to(
        overview({
          appCode: 'aiad',
        }),
      );
      if (!err) {
        this.overview = res;
      }
    },

    // 获取当前组织的未读消息
    async fetchUnreadNotifyNum() {
      const [err, res] = await to(
        unreadMessageNum({
          appCode: 'aiad',
        }),
      );
      if (!err) {
        this.unreadNum = res;
      }
    },

    // 读消息
    async readNotify(id: string) {
      const [err] = await to(readMessage({ messageIds: [id], appCode: 'aiad' }));
      // 将消息变成已读
      if (!err) {
        const target = this.notifies.find((v) => v.id === id);
        target && (target.hasRead = true);
      }
    },

    // 读全部消息
    async readAllNotify() {
      const [err] = await to(readAll({ appCode: 'aiad' }));
      if (!err) {
        this.notifies.forEach((v) => (v.hasRead = true));
        this.unreadNum = 0;
      }
    },
  },
});

export function useNotifyStoreWithOut() {
  return useNotifyStore();
}
